export default __webpack_public_path__ + "static/media/accordian-up.f0834596.svg";